/**
 * Cell link modal component
 *
 * Cell link modal for ag-grid that shows a pop-up.
 */
import { Component, Injector } from '@angular/core';
import { UiActions } from '@app/store/actions/ui';
import { AgRendererComponent } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { get } from 'lodash';

// eslint-disable-next-line @angular-eslint/prefer-on-push-component-change-detection
@Component({
  selector: 'xvi-modal-link-render',
  templateUrl: 'modal-link-renderer.component.html',
  styleUrls: ['modal-link-renderer.component.scss'],
})
export class XVIModalLinkRendererComponent implements AgRendererComponent {
  public params:
    | (ICellRendererParams & { showModalDialogHandler?: Function })
    | null = null;
  public value: string = '';
  public isStopPropagation: boolean = false;

  public constructor(
    public injector: Injector,
    public uiActions: UiActions,
  ) {}

  public agInit(params: ICellRendererParams): void {
    this.params = params;
    this.value = params.valueFormatted || params.value;
    this.isStopPropagation = get(
      params,
      'isStopPropagation',
      this.isStopPropagation,
    );
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  public refresh(params: ICellRendererParams): boolean {
    return false;
  }

  public async showModalDialog(event: MouseEvent): Promise<void> {
    if (this.isStopPropagation) {
      event.preventDefault();
      event.stopPropagation();
    }

    const isPendingTransfer = get(this.params, 'isPendingTransfer', false);

    const modalOptions = this.params.showModalDialogHandler(
      this.params,
      isPendingTransfer ? 'pendingTransferDialog' : null,
    );
    await this.uiActions.formModalDialog(modalOptions);

    return;
  }
}
